import { getAnonId } from "./identity.js";

/**
 * Fire-and-forget funnel beacon → POST /api/e (same-origin, Analytics Engine behind
 * it). sendBeacon survives page unload; fetch keepalive is the fallback. Analytics
 * must NEVER break a game — every path swallows.
 *
 * Funnel: page_view → play_start → play_done → card_ready → share_done (+ link_copy).
 * Server-side events (score_submit, spin, crash_*) are written by the API directly.
 */
export function track(
  game: string,
  event: string,
  value?: number,
  extra?: string,
): void {
  try {
    const payload = JSON.stringify({
      game,
      event,
      anonId: getAnonId(),
      ...(value !== undefined ? { value } : {}),
      ...(extra !== undefined ? { extra } : {}),
    });
    const blob = new Blob([payload], { type: "application/json" });
    if (typeof navigator !== "undefined" && navigator.sendBeacon?.("/api/e", blob)) {
      return;
    }
    void fetch("/api/e", { method: "POST", body: payload, keepalive: true }).catch(
      () => {},
    );
  } catch {
    /* analytics never breaks the game */
  }
}

/** Page-view beacon carrying the referrer host — makes x.com / t.co arrivals visible. */
export function trackPageView(game: string): void {
  let ref = "";
  try {
    ref = document.referrer ? new URL(document.referrer).hostname : "";
  } catch {
    /* unparseable referrer — drop it */
  }
  track(game, "page_view", undefined, ref);
}
